import { KnowMore } from '../../../Common/buttons/know-more';
import { TUseCaseFoldCards } from './constants';

export const UseCaseCard: React.FC<{ card: TUseCaseFoldCards }> = ({
  card,
}) => {
  return (
    <div className="p-6 bg-white w-full">
      <img className="w-12 h-12" src={card.icon} alt="icon"></img>
      <p className="text-font-500 font-bold text-s-18 pt-4 h-16 md:text-base">
        {card.title}
      </p>
      <p className="pt-4 text-base font-medium text-font-200 h-28 md:text-s-14 sm:h-16">
        {card.description}
      </p>
      <KnowMore
        href={'https://cleartax.in/income-tax-efiling'}
        funnelMetricLabel="use-case-fold"
        className="ml-0 pt-4 block md:text-s-14"
      />
    </div>
  );
};
